import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'quartz-routing/react-router';
import { useACNavigate } from 'academy-common-lib/hooks/useACNavigate';

/**
 * Hook to help public achievement redirect to canonical url if necessary.
 *
 * actualSlug  - the slug from the current page href
 * replaceSlug - callback to change the page url
 * urlSlug     - the slug associated with the achievement
 */
const useSettledUrl = ({
  actualSlug,
  urlSlug
}) => {
  const [isSettled, setIsSettled] = useState(false);
  const location = useLocation();
  const navigate = useACNavigate();
  const replaceSlug = useCallback((actual, url) => {
    navigate(location.pathname.replace(actual, url), {
      replace: true
    });
  }, [navigate, location.pathname]);
  useEffect(() => {
    if (!isSettled && typeof urlSlug === 'string') {
      if (urlSlug !== actualSlug) {
        replaceSlug(actualSlug, urlSlug);
      }
      setIsSettled(true);
    }
  }, [actualSlug, isSettled, replaceSlug, urlSlug]);
  return isSettled;
};
export default useSettledUrl;